document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById("custom_convertor-checkbox");
  const inputField = document.getElementById("custom_calculator-input");
  const boxQty = document.getElementById("cal_box-qty");
  const m2Val = document.getElementById("cal_m2-val");
  const fieldSymbol = document.getElementById("custom_calc-symbol");
  const increasedVal = document.getElementById("cuts_wastage");
  const tileDrawer = document.getElementById("custom_tile-quantity-calculator");
  const drawerBtn = document.getElementById("tile_quantity-drawer");
  const closeIconTile = tileDrawer.querySelector(".tile-close-drawer");
  const qunatityField = document.getElementById("custom_tile-quantity-field");
  const totalPriceTiles = document.getElementById("totalPrice-tiles");
  const tilesPriceCust = document.getElementById("tiles_custom-price");
  
  const initialM2Value = parseFloat(inputField.value);
  const initialM2Calc = parseFloat(m2Val.getAttribute("data-calc"));
  const initialBoxQty = parseFloat(boxQty.getAttribute("data-qty"));
  
  // const productType = document.querySelector("#custom_product-type");
  // if(inputField.value !== "" && productType.value !== "sheet") {
  //   const m2perbox = parseFloat(tilesPriceCust.value/100)/initialM2Value;
  //   const updatedPrice = `<strong>$${m2perbox.toFixed(2)}/m²</strong> = $${(tilesPriceCust.value/100).toFixed(2)}/${productType.value}`;
  //   const priceField = document.querySelector(".price__default");
  //   priceField.innerHTML = updatedPrice;
  // }  
  
  const addEvent = (el, ev, fn) => el && el.addEventListener(ev, fn);

  addEvent(checkbox, "change", () => switchValues(checkbox.checked));
  addEvent(inputField, "input", () => handleCalculation(checkbox.checked));
  addEvent(increasedVal, "change", () => handlePercentage(checkbox.checked, increasedVal.checked));
  addEvent(drawerBtn, "click", () => handleOpenDrawer());
  addEvent(closeIconTile, "click", () => handleCloseDrawer());

  function handleCalculation(isChecked) {
    const productType = document.querySelector("#custom_product-type");
    
    if(!inputField.value || inputField.value < 1) {
      return;
    }
    increasedVal.checked = false;
    let inputValue = parseFloat(inputField.value);
    const newM2Cal = isChecked ? inputValue / initialM2Value : inputValue;
    const calculatedM2Value = Math.ceil(newM2Cal) * initialM2Calc;
    
     m2Val.setAttribute("data-calc", isChecked ? calculatedM2Value : Math.ceil(inputValue) * initialM2Value);
     boxQty.setAttribute("data-qty", Math.ceil(newM2Cal));
     boxQty.innerText = isChecked ? `${Math.ceil(newM2Cal)} ${productType.value}` : "";
     m2Val.innerHTML = isChecked ? `(${calculatedM2Value.toFixed(2)})m<sup>2</sup>` : `${(Math.ceil(inputValue) * initialM2Value).toFixed(2)}m<sup>2</sup>`;
    qunatityField.value = Math.ceil(newM2Cal);
    totalPriceTiles.innerText = Math.ceil(newM2Cal) * initialM2Value
    totalPriceTiles.innerText = `$${formatCurrency((Math.ceil(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
    fieldSymbol.innerHTML = isChecked ? `m<sup>2</sup>` : (inputField.value == 1 ? `${productType.value}` : `${productType.value}${productType.value === "box" ? `es` : `s`}`);
  }

  function switchValues(isChecked) {
    const productType = document.querySelector("#custom_product-type");
    const initialM2CalcValue = parseFloat(m2Val.getAttribute("data-calc"));
    const initialBoxQtyValue = parseFloat(boxQty.getAttribute("data-qty"));
    
    inputField.value = isChecked ? initialM2CalcValue.toFixed(2) : initialBoxQtyValue;
    fieldSymbol.innerHTML = isChecked ? `m<sup>2</sup>` : (inputField.value == 1 ? `${productType.value}` : `${productType.value}${productType.value === "box" ? `es` : `s`}`);
    
    boxQty.innerText = isChecked ? `${Math.ceil(initialBoxQtyValue)} ${productType.value}` : "";
    m2Val.innerHTML = isChecked ? `(${initialM2CalcValue.toFixed(2)})m<sup>2</sup>` : `${initialM2CalcValue.toFixed(2)}m<sup>2</sup>`;
    totalPriceTiles.innerText = `$${formatCurrency((Math.ceil(initialBoxQtyValue) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
  }

  
  function handlePercentage(isChecked, isIncreased) {
      let inputValue = parseFloat(inputField.value);
    console.log("initialM2Value", initialM2Value)
      if(isIncreased) {
        if(isChecked) {
          inputValue = inputValue*1.1;
          let newM2Cal =  inputValue / initialM2Value;
          let calculatedM2Value = Math.ceil(newM2Cal) * initialM2Calc;
          qunatityField.value = Math.ceil(newM2Cal);
          inputField.value =inputValue.toFixed(2);
          totalPriceTiles.innerText = `$${formatCurrency((Math.ceil(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
          hanleText(newM2Cal, calculatedM2Value);
        } else {
          inputValue = inputValue*1.1;
          let newM2Cal =  inputValue;
          let calculatedM2Value = Math.ceil(newM2Cal) * initialM2Calc;
          inputField.value = Math.ceil(inputValue);
          qunatityField.value = Math.ceil(newM2Cal);
          totalPriceTiles.innerText = `$${formatCurrency((Math.ceil(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
          hanleText(null, calculatedM2Value);
        }
      } else {
        if(isChecked) {
          inputValue = inputValue/1.1;
          let newM2Cal =  inputValue / initialM2Value;
          let calculatedM2Value = Math.ceil(newM2Cal) * initialM2Calc;
          inputField.value =inputValue.toFixed(2);
          qunatityField.value = Math.ceil(newM2Cal);
          totalPriceTiles.innerText = `$${formatCurrency((Math.ceil(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
          if(initialM2Value < 1) {
            if(newM2Cal > 1) {
              calculatedM2Value = Math.floor(newM2Cal) * initialM2Calc;
              hanleText(Math.floor(newM2Cal), calculatedM2Value); 
              totalPriceTiles.innerText = `$${formatCurrency((Math.floor(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
            } else {
              hanleText(Math.ceil(newM2Cal), calculatedM2Value); 
              totalPriceTiles.innerText = `$${formatCurrency((Math.ceil(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
            }
            
          } else {
            hanleText(newM2Cal, calculatedM2Value);
          }
        } else {
          inputValue = inputValue/1.1;
          const newM2Cal =  inputValue;
          const calculatedM2Value = Math.floor(newM2Cal) * initialM2Calc;
          inputField.value = Math.floor(newM2Cal);
          qunatityField.value = Math.floor(newM2Cal);
          totalPriceTiles.innerText = `$${formatCurrency((Math.floor(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
          hanleText(null, calculatedM2Value);
        }
      }
  }
  

  // function handlePercentage(isChecked, isIncreased) {
  //     let inputValue = parseFloat(inputField.value);
  //     if(isIncreased) {
  //       if(isChecked) {
  //         inputValue = inputValue*1.1;
  //         const newM2Cal =  inputValue / initialM2Value;
  //         const calculatedM2Value = Math.ceil(newM2Cal) * initialM2Calc;
  //         qunatityField.value = Math.ceil(newM2Cal);
  //         inputField.value =inputValue.toFixed(2);
  //         totalPriceTiles.innerText = `$${formatCurrency((Math.ceil(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
  //         hanleText(newM2Cal, calculatedM2Value);
  //       } else {
  //         inputValue = inputValue*1.1;
  //         const newM2Cal =  inputValue;
  //         const calculatedM2Value = Math.ceil(newM2Cal) * initialM2Calc;
  //         inputField.value = Math.ceil(inputValue);
  //         qunatityField.value = Math.ceil(newM2Cal);
  //         totalPriceTiles.innerText = `$${formatCurrency((Math.ceil(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
  //         hanleText(null, calculatedM2Value);
  //       }
  //     } else {
  //       if(isChecked) {
  //         inputValue = inputValue/1.1;
  //         const newM2Cal =  inputValue / initialM2Value;
  //         let calculatedM2Value = Math.ceil(newM2Cal) * initialM2Calc;
  //         inputField.value =inputValue.toFixed(2);
  //         qunatityField.value = Math.floor(newM2Cal);
  //         console.log(newM2Cal,"newM2Cal===>", formatCurrency((Math.ceil(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2)))
  //         totalPriceTiles.innerText = `$${formatCurrency((Math.floor(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
          // if(initialM2Value < 1) {
          //   if(newM2Cal > 1) {
          //     calculatedM2Value = Math.floor(newM2Cal) * initialM2Calc;
          //     hanleText(Math.floor(newM2Cal), calculatedM2Value); 
          //   } else {
          //     hanleText(Math.ceil(newM2Cal), calculatedM2Value); 
          //   }
            
          // } else {
          //   hanleText(newM2Cal, calculatedM2Value);
          // }
  //         hanleText(newM2Cal, calculatedM2Value);
  //       } else {
  //         inputValue = inputValue/1.1;
  //         const newM2Cal =  inputValue;
  //         const calculatedM2Value = Math.floor(newM2Cal) * initialM2Calc;
  //         inputField.value = Math.floor(newM2Cal);
  //         qunatityField.value = Math.floor(newM2Cal);
  //         totalPriceTiles.innerText = `$${formatCurrency((Math.floor(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
  //         hanleText(null, calculatedM2Value);
  //       }
  //     }
  // }
  

  function hanleText(boxVal, m2Value) {
    const productType = document.querySelector("#custom_product-type");
    m2Val.setAttribute("data-calc", m2Value);
    if(boxVal) {
      boxQty.setAttribute("data-qty", Math.ceil(boxVal));
    }
    boxQty.innerText = boxVal ? `${Math.ceil(boxVal)} ${productType.value}` : "";
    m2Val.innerHTML = boxVal ? `(${m2Value.toFixed(2)})m<sup>2</sup>` : `${m2Value.toFixed(2)}m<sup>2</sup>`;
  }

  function handleOpenDrawer() {
    tileDrawer.classList.add("open");
    const customOverlay = document.querySelector("#custom_tile_overlay");
    // const overlayElement = document.querySelector('.homer-hub_overlay');
    if (customOverlay) {
        setTimeout(() => {
            customOverlay.classList.add('is-visible');
        }, 200);
    }
  }

  function handleCloseDrawer() {
      setTimeout(() => {
        tileDrawer.classList.remove("open");
      }, 300);
    
    const customOverlay = document.querySelector("#custom_tile_overlay");
    if (customOverlay) {
        setTimeout(() => {
            customOverlay.classList.remove('is-visible');
        }, 200);
    }
  }

  const areasContainer = document.getElementById('areas');
  const addAreaButton = document.getElementById('add-area');
  const unitRadios = document.querySelectorAll('input[name="unit"]');
  const totalAreaField = document.createElement('input');
  const drawerQuantity = document.getElementById("tile-drawer-quantity");
  const TotalCont = document.getElementById("custom_total_value_cont");
  
  addEvent(drawerQuantity, "click", () => handleTotalDrawer());
  
    // Set up total area field
    totalAreaField.setAttribute('type', 'number');
    totalAreaField.setAttribute('readonly', true);
    totalAreaField.setAttribute('placeholder', 'Total sq. m');
    totalAreaField.setAttribute('class', 'cal-content-input');
    TotalCont.append(totalAreaField);

    // Function to calculate area
    function calculateArea(row) {
        const width = row.querySelector('.width').value;
        const length = row.querySelector('.length').value;
        const area = row.querySelector('.area');
      
        area.value = (width*length).toFixed(2);
        updateTotalArea();
    }

  let rowCounter = 1;

    // Function to add new area row
    function addAreaRow() {
        const newRow = document.createElement('div');
        newRow.classList.add('area-row');
        newRow.innerHTML = `
            <span class="row-number cal-content-number">${rowCounter}.</span>
            <input type="number" class="width cal-content-input" placeholder="width (m)">
            <span class="cal-content-symbol">x</span>
            <input type="number" class="length cal-content-input" placeholder="length (m)">
            <span class="cal-content-symbol">=</span>
            <input type="number" class="area cal-content-input" placeholder="sq. m" readonly>
            <button class="remove-btn cal-content-symbol">${rowCounter === 1 ? "" : `<svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M5 19 19 5M5 5l14 14"></path></svg>`}</button>
        `;
        
        // Add event listeners for new inputs
        newRow.querySelector('.width').addEventListener('input', () => calculateArea(newRow));
        newRow.querySelector('.length').addEventListener('input', () => calculateArea(newRow));
        newRow.querySelector('.remove-btn').addEventListener('click', () => {
            newRow.remove();
            rowCounter--;
            updateTotalArea();
            updateRowNumbers();
        });

        areasContainer.appendChild(newRow);
        rowCounter++;
    }

  function updateRowNumbers() {
    const rows = areasContainer.querySelectorAll('.area-row');
    for (let i = 0; i < rows.length; i++) {
        if(rows[i].querySelector('.row-number')) {
          rows[i].querySelector('.row-number').textContent = `${i}.`;
        }
    }
    rowCounter = rows.length;
}

    // Function to update total area
    function updateTotalArea() {
        const rows = areasContainer.querySelectorAll('.area-row');
        let total = 0;
        let unit = document.querySelector('input[name="unit"]:checked').value;
        let multiplier = unit === 'millimetres' ? 0.000001 : 1;
      
        rows.forEach(row => {
            const area = parseFloat(row.querySelector('.area').value);
            if (!isNaN(area)) {
                total += area*multiplier;
            }
        });
        totalAreaField.value = formatNumber(total, 2);
    }

    function formatNumber(value, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces);
      return (Math.ceil(value * factor) / factor).toFixed(decimalPlaces);
    }

    // Initial area row
    for(let i = 0; i<4; i++) {
      addAreaRow();
    }

  function formatCurrency(num) {
    return parseFloat(num).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');;
  }

    // Add new area row on button click
    addAreaButton.addEventListener('click', addAreaRow);

    function handleTotalDrawer() {
      const finalValue =  totalAreaField.value;
      const newM2Cal = finalValue / initialM2Value;
      const calculatedM2Value = Math.ceil(newM2Cal) * initialM2Calc;
      
      if(finalValue > 0) {
        hanleText(newM2Cal, calculatedM2Value);
        checkbox.checked = true;
        inputField.value = finalValue;
        qunatityField.value =  Math.ceil(newM2Cal);
        handleCloseDrawer();
        totalPriceTiles.innerText = `$${formatCurrency((Math.ceil(newM2Cal) * (parseFloat(tilesPriceCust.value)/100)).toFixed(2))}`;
      }
    }

    // Recalculate all areas on unit change
    unitRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
            const isMillimeter = e.currentTarget.value === 'millimetres';
            const rows = areasContainer.querySelectorAll('.area-row');
            rows.forEach(row => {
              const widthInput = row.querySelector('.width');
              const lengthInput = row.querySelector('.length');
            
              widthInput.placeholder = isMillimeter ? 'width (mm)' : 'width (m)';
              lengthInput.placeholder = isMillimeter ? 'length (mm)' : 'length (m)';

              calculateArea(row);
              
            });
        });
    });
  
  switchValues(checkbox.checked);
  
});
